import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from "react-helmet";
import ForexListDisplay from './ForexListDisplay';
import '../../css/blink.css';

class ForexWrap extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Forex Screener</title> 
          <link rel="canonical" href="https://www.vizfm.com/forex" />
          <meta name="description" content="Forex (FX) Screener for Investors and Traders" />
        </Helmet>
        <Container fluid className="p-2">
          <Row>
            <Col xs={3} sm={3} md={2} lg={1} xl={1}>
              <div className="waitingForConnection3">
                Live <i className="fa fa-asterisk"></i>
              </div>
            </Col>
            <Col xs={9} sm={9} md={10} lg={11} xl={11}>Forex Screener</Col>
          </Row>
          <Row>
            <Col><ForexListDisplay /></Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default ForexWrap;
